Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityRefreshView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_refresh']

  render: =>
    @$el.html(@template())
    @$el.find('button').on 'click', (event) =>
      @disable()
      @trigger('refresh')
    @

  enable: =>
    @$el.find('button').prop('disabled', false)

  disable: =>
    @$el.find('button').prop('disabled', true)
